import type { StepType } from 'components/layout';
import ChooseCreatives from './ChooseCreatives';
import ChooseAccount from './ChooseAccount';
import ChooseCampaigns from './ChooseCampaigns';
import ChooseLineItems from './ChooseLineItems';
import AdSettingsStep from './AdSettingsStep';

export const TWITTER_STEPS: StepType[] = [
  { title: 'Creatives', component: ChooseCreatives },
  { title: 'Ad Account', component: ChooseAccount },
  { title: 'Campaigns', component: ChooseCampaigns },
  { title: 'Ad groups', component: ChooseLineItems },
  { title: 'Ads', component: AdSettingsStep },
];
